/**
 * @author Ivan Toth.
 */
'use strict';
var DetailGoeValidController = (function () {
    function DetailGoeValidController(topic, $scope) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.lock = true;
        this.completeSection = 'goePick_valid';
        this.comp = 'goe_valid';
        this.updateArray = ['goe_valid'];
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.comp)) {
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
        this.goeOptions = ['Yes', 'No', 'Unknown', 'State Owned'];
    }
    DetailGoeValidController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
    };
    DetailGoeValidController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus(this.updateArray, 'Updating')) {
                this.topic.sendForUpdateGeneral(this.updateArray, true);
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    DetailGoeValidController.$inject = ['topic', '$scope'];
    return DetailGoeValidController;
}());
var DetailGoeValidComponent = (function () {
    function DetailGoeValidComponent() {
        this.templateUrl = 'detail-goe-valid.html';
        this.controllerAs = 'vm';
        this.controller = DetailGoeValidController;
    }
    return DetailGoeValidComponent;
}());
angular
    .module('application')
    .component('goeValidSection', new DetailGoeValidComponent());

//# sourceMappingURL=detail.validation.goe.component.js.map
